import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\CreateChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/CreateChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing/connexion'
*/
const CreateChiftInvoicingConnexionController = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateChiftInvoicingConnexionController.url(args, options),
    method: 'post',
})

CreateChiftInvoicingConnexionController.definition = {
    methods: ["post"],
    url: '/api/company/{company}/partners/chift-invoicing/connexion',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\CreateChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/CreateChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing/connexion'
*/
CreateChiftInvoicingConnexionController.url = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return CreateChiftInvoicingConnexionController.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Partner\ChiftInvoicing\CreateChiftInvoicingConnexionController::__invoke
* @see app/Http/Controllers/Partner/ChiftInvoicing/CreateChiftInvoicingConnexionController.php
* @route '/api/company/{company}/partners/chift-invoicing/connexion'
*/
CreateChiftInvoicingConnexionController.post = (args: { company: string | number | { id: string | number } } | [company: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateChiftInvoicingConnexionController.url(args, options),
    method: 'post',
})

export default CreateChiftInvoicingConnexionController